import { createContext, useContext, useState, useEffect } from 'react';

const GlobalStateContext = createContext();

export const GlobalStateProvider = ({ children }) => {
  const [isErrorVisible, setErrorVisible] = useState(false);
  const [isNetworkErrorVisible, setNetworkErrorVisible] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [voyceToken, setVoyceToken] = useState(
    localStorage.getItem('clientSignupToken') || 
    sessionStorage.getItem('clientSignupToken') || '');
  const [errorMessage, setErrorMessage] = useState('');
  const [tempClientId, setTempClientId] = useState('');
  const [uniqueToken, setUniqueToken] = useState('');
  const [remember, setRemember] = useState(null);
  useEffect(() => {
    if (!voyceToken) {
      localStorage.removeItem('clientSignupToken');
      localStorage.removeItem('PersonWEYIToken');
      sessionStorage.removeItem('clientSignupToken');
      sessionStorage.removeItem('PersonWEYIToken');
      return
    }
    localStorage.setItem('PersonWEYIToken', voyceToken);
    if (remember === true) {
      localStorage.setItem('clientSignupToken', voyceToken);
    } else if (remember === false) {
      sessionStorage.setItem('clientSignupToken', voyceToken);
    }
    
  }, [remember, voyceToken]);
  useEffect(() => {
    if (tempClientId) {
      localStorage.setItem('tempClientId', tempClientId);
    } else {
      localStorage.removeItem('tempClientId');
    }
  }, [tempClientId]);
  useEffect(() => {
    if (uniqueToken) {
      localStorage.setItem('uniqueToken', uniqueToken);
    } else {
      localStorage.removeItem('uniqueToken');
    }
  }, [uniqueToken]);


  return (
    <GlobalStateContext.Provider value={{
      isErrorVisible, setErrorVisible,
      isLoading, setLoading,
      voyceToken, setVoyceToken,
      errorMessage, setErrorMessage,
      tempClientId, setTempClientId,
      uniqueToken, setUniqueToken,
      remember, setRemember,
      isNetworkErrorVisible, setNetworkErrorVisible,
    }}>
      {children}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => useContext(GlobalStateContext);
